export default __webpack_public_path__ + "static/media/bulk-contacts.042d4b87.jpg";